/* Component Dependencies */
var forgotPasswordTemplate = require('templates/forgotPassword.hbs');
var PostalAddressBase = require('libs/postalAddress-base');
var emailValidationHandler = require('utils/emailValidation.js');
var PubSub = require('libs/pub-sub');

PubSub.register(PostalAddressBase.extend({
  type: 'forgotPassword',
  template: {
    'forgotPassword': forgotPasswordTemplate
  },
  defObj: {
    addressSection: ''
  },
   events: {
        'click .js-btn-submit': 'validationEmail'
   },

  bindEvents: function($) {
    var _self = this;
    _self.bindPostalAddressBase();
    _self.bindChangeEvent($);
    var lookupLink = $(".js-forgetPassword-lookup a");
    lookupLink.attr('custom_click_track_value',"Forgot Password|Look Up Member Number Link|internal|event167");
    lookupLink.addClass('custom_click_track');
  },

	validationEmail: function _validationEmail(e) {
        var mobileAuthEnabledEmailValidation = $('.js-emailValidation').val();
        var mobileAuthEnabledRegex = /^[0-9+ ]+$/;
        var isMobileAuthEnabledEmailValidation = mobileAuthEnabledRegex.test(mobileAuthEnabledEmailValidation);
        var mobileAuthEnabled= $('.js-emailValidation').data('mobile-auth-enabled');
        if(mobileAuthEnabled==true) {
            if(!isMobileAuthEnabledEmailValidation) {
               if(emailValidationHandler.emailValidation($('.js-emailValidation').val(), 'all')) {
               			$('#email-validation').addClass('l-display-none');
	               }
               else {
               	$('#email-validation').removeClass('l-display-none');
               	if($('.tile-error-messages')) {
               				$('.tile-error-messages').addClass('l-display-none');
               	}  
               	e.preventDefault(); 
               }
            }
        }
        else {
            if(emailValidationHandler.emailValidation($('.js-emailValidation').val(), 'all')) {
															$('#email-validation').addClass('l-display-none');
            }
            else {
															$('#email-validation').removeClass('l-display-none');
                   if($('.tile-error-messages')) {
                       $('.tile-error-messages').addClass('l-display-none');
                   }
                    e.preventDefault();
            }
        }
	}
}));
